// Deterministic JSON stringify: sorts object keys recursively
export function stableStringify(value: unknown): string {
  const seen = new WeakSet<object>();

  const serialize = (val: any): any => {
    if (val === null || typeof val !== 'object') return val;
    if (seen.has(val)) throw new Error('Cannot stringify circular structure');
    seen.add(val);
    if (Array.isArray(val)) return val.map(serialize);
    const keys = Object.keys(val).sort();
    const out: Record<string, any> = {};
    for (const k of keys) out[k] = serialize(val[k]);
    return out;
  };

  return JSON.stringify(serialize(value));
}


